import React from "react";

import {useFeedbackTools} from "../../../../components/FeedbackTools";
import {useFormik} from "formik";
import * as yup from "yup";
import {ResponsiveDialog} from "../../../../components/ResponsiveDialog";
import DialogContent from "@mui/material/DialogContent";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import CountryFlag from "../../../../components/CountryFlag";


const EditPropertyInstructionDialog = ({instruction, onSave, onClose}) => {
    const {showSuccessNotification, showErrorNotification} = useFeedbackTools();
    const newRecord = !instruction?.id;

    const formik = useFormik({
        initialValues: {
            category: instruction?.category ?? '',
            contentIt: instruction?.contentIt ?? '',
            contentEn: instruction?.contentEn ?? '',
        },
        validationSchema: yup.object().shape({
            contentIt: yup.string().required('Campo obbligatorio'),
            contentEn: yup.string().required('Campo obbligatorio'),
        }),
        onSubmit: async (values) => {
            try {
                const instructionData = newRecord ? values : {...values, id: instruction.id};
                await onSave(instructionData);
                onClose();
                showSuccessNotification('Elemento salvato con successo');
            } catch (e) {
                showErrorNotification(e);
            }
        }
    });

    return <ResponsiveDialog isOpen={true}
                             onClose={onClose}
                             title={newRecord ? "Nuovo Elemento" : "Modifica Elemento"}
                             onApply={formik.handleSubmit}
                             showApply={true}
                             enableApply={!Object.keys(formik.errors).some(x => formik.touched[x])}
                             isLoading={formik.isSubmitting}
    >
        <DialogContent>
            <Stack spacing={2} sx={{pt: 1}}>
                <TextField fullWidth
                           name="contentIt"
                           label="Contenuto (IT)"
                           value={formik.values.contentIt}
                           onChange={formik.handleChange}
                           error={formik.touched.contentIt && Boolean(formik.errors.contentIt)}
                           helperText={formik.touched.contentIt && formik.errors.contentIt}
                           multiline
                           rows={2}
                           InputProps={{
                               startAdornment: <InputAdornment position="start">
                                   <CountryFlag code="IT"/>
                               </InputAdornment>
                           }}>
                </TextField>

                <TextField fullWidth
                           name="contentEn"
                           label="Contenuto (EN)"
                           value={formik.values.contentEn}
                           onChange={formik.handleChange}
                           error={formik.touched.contentEn && Boolean(formik.errors.contentEn)}
                           helperText={formik.touched.contentEn && formik.errors.contentEn}
                           multiline
                           rows={2}
                           InputProps={{
                               startAdornment: <InputAdornment position="start">
                                   <CountryFlag code="GB"/>
                               </InputAdornment>
                           }}>
                </TextField>

            </Stack>
        </DialogContent>
    </ResponsiveDialog>
}

export default EditPropertyInstructionDialog;